import Q from 'q';

import API from 'js/lib/api';

const enterpriseEmailReportsAPI = API('/api/enterpriseEmailReports.v1/', {
  type: 'rest',
});

export type CreateReportOptions = {
  includeExpiredContract?: boolean;
  includeNonBillableContract?: boolean;
  includeBillableContract?: boolean;
};

export const CreateReportOptionSet = {
  allActive: {
    includeExpiredContract: false,
    includeNonBillableContract: true,
    includeBillableContract: true,
  },
  allBillable: {
    includeExpiredContract: true,
    includeNonBillableContract: false,
    includeBillableContract: true,
  },
  all: {
    includeExpiredContract: true,
    includeNonBillableContract: true,
    includeBillableContract: true,
  },
} as const;

export type CreateReportScopeKey = keyof typeof CreateReportOptionSet;

export type UsageReportV2Options = {
  reportScope?: CreateReportScopeKey;
  programIds?: Array<string>;
  oneCsvPerProgram?: boolean;
  includeDeletedMembers?: boolean;
  startDate?: string;
  endDate?: string;
  courseId?: string;
};

export const createReportV2 = (
  thirdPartyOrganizationId: string,
  {
    reportScope = 'allActive',
    oneCsvPerProgram = false,
    programIds = undefined,
    startDate = undefined,
    endDate = undefined,
    courseId = undefined,
    includeDeletedMembers = true,
  }: UsageReportV2Options
) => {
  const data = {
    reportScope: {
      typeName: 'programReportScope',
      definition: {
        programIds,
        thirdPartyOrganizationId,
        ...CreateReportOptionSet[reportScope],
      },
    },
    startDate,
    endDate,
    oneCsvPerProgram,
    includeDeletedMembers,
    courseId,
  };

  return Q(enterpriseEmailReportsAPI.post('', { data }));
};
